import React from 'react';
import { Chip } from '@mui/material';

const CONFIG = {
  good: { label: 'Good', color: 'success', emoji: '🟢' },
  needs_attention: { label: 'Needs attention', color: 'warning', emoji: '🟡' },
  problem: { label: 'Problem', color: 'error', emoji: '🔴' },
};

export default function HealthStatusChip({ status, showEmoji = true }) {
  const cfg = CONFIG[status] || CONFIG.good;
  return (
    <Chip
      size="small"
      color={cfg.color}
      label={showEmoji ? `${cfg.emoji} ${cfg.label}` : cfg.label}
      sx={{ fontWeight: 600 }}
    />
  );
}
